export class ProvisionTypeNotGivenError extends Error {
    public constructor() {
        super('Provision type is not given');
    }
}
